import { RouteOption } from '../types';

/**
 * Rutas disponibles en la aplicación
 */
export const ROUTES: RouteOption[] = [
  { id: '68', name: 'Ruta 68', destination: 'Santiago – Valparaíso', subtext: 'Autopista del Pacífico' },
  { id: '78', name: 'Ruta 78', destination: 'Santiago – San Antonio', subtext: 'Autopista del Sol' },
];

/**
 * Destinos geográficos por ruta
 */
export const DESTINATIONS: Record<string, { lat: number; lon: number; name: string }> = {
    '68': { lat: -33.0245, lon: -71.5523, name: 'Viña del Mar' },
    '78': { lat: -33.5938, lon: -71.6067, name: 'San Antonio' }
};

/**
 * Coordenadas de origen y destino para Google Maps Directions API
 * Optimizado para obtener duraciones estimadas
 */
export const ROUTE_COORDINATES: Record<string, {
  origin: { lat: number; lon: number; name: string };
  destination: { lat: number; lon: number; name: string };
}> = {
  '68': {
    origin: { lat: -33.4489, lon: -70.6693, name: 'Santiago' },
    destination: { lat: -33.0245, lon: -71.5523, name: 'Viña del Mar' }
  },
  '78': {
    origin: { lat: -33.4489, lon: -70.6693, name: 'Santiago' },
    destination: { lat: -33.5938, lon: -71.6067, name: 'San Antonio' }
  }
};

